export default __webpack_public_path__ + "static/media/1220.edf4a40c.png";